import constant from "lib/constant/constant";

const { onboardingSteps } = constant;
const { APP_PERMISSION, COMMISSION, FINISH, UPDATE_PROFILE } = onboardingSteps;

const tabs = [
  {
    id: UPDATE_PROFILE,
    content: "Step 1",
    accessibilityLabel: "updateProfile",
    panelID: "updateProfile-content",
    tabIndex: 0,
  },
  {
    id: COMMISSION,
    content: "Step 2",
    accessibilityLabel: "Commission settings",
    panelID: "commission-content",
    tabIndex: 1,
  },
  {
    id: APP_PERMISSION,
    content: "Step 3",
    panelID: "appPermission-content",
    tabIndex: 2,
  },
  {
    id: FINISH,
    content: "Finish Setup",
    panelID: "finish-content",
    tabIndex: 3,
  },
];

export default tabs;
